import styled from 'styled-components';
import { device } from '../../helpers';
export * from './NoResults';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
`;

const List = styled.div<{ more: boolean }>`
    margin: ${(p) => (p.more ? '36px 0 0 0' : '36px 0')};
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    @media ${device.phone} {
        margin: ${(p) => (p.more ? '18px 0 0 0' : '18px 0')};
    }
`;

function showMore({
    enableMore,
    stats,
}: {
    enableMore: boolean;
    stats: { offset: number; total: number };
}) {
    if (!enableMore) {
        return false;
    }

    const { offset, total } = stats;
    if (offset < total) {
        return true;
    }

    return false;
}

type Props = {
    children: JSX.Element | JSX.Element[];
    stats: { offset: number; total: number };
    onMore: () => void;
    enableMore?: boolean;
};
export function Results({ children, stats, onMore, enableMore = true }: Props) {
    return (
        <Container>
            <List more={showMore({ enableMore, stats })}>{children}</List>
        </Container>
    );
}
